module.exports = __webpack_public_path__ + "static/media/IntroPracticeRanking.e74c9e4e.svg";